import { CustomizacaoSubmenuEnum } from "src/app/shared/enums/CustomizacaoSubmenuEnum";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ParametrosDataService } from "src/app/services/parametros-data.service";
import { ParametrosKey } from "src/app/shared/enums/parametros.enum";

@Component({
    selector: "app-dado-empresa",
    templateUrl: "./dado-empresa.component.html",
    styleUrls: ["./dado-empresa.component.scss"]
})
export class DadoEmpresaComponent implements OnInit {
    constructor(
        private router: Router,
        private parametrosDataService: ParametrosDataService
    ) {}

    ngOnInit() {
        const canAccess = this.parametrosDataService.ShowSubmenu(
            CustomizacaoSubmenuEnum.dadosEmpresa
        );

        if (!canAccess) {
            this.router.navigate(["accessdenied"]);
        }
    }
}
